import { Text } from '@ttc3k/trekker'
import { PropsWithChildren } from 'react';
type ErrorTextProps = PropsWithChildren

export const ErrorText = ({children}: ErrorTextProps) => {
  return (
    <Text visual={"bodySemiBold"} color={"text.error.mid"}>
      {children}
    </Text>
  );
};
